export function getSelectOptionsFromStrArr(arr: string[], t = (key: string) => key): SelectOption[] {
  return arr.map((item) => ({
    label: t(item),
    value: item,
  }));
}
